import { enableMultiCarrierPlans } from 'utils/experiments'
import getPolicy from './getPolicy'

const getLabelMultiCarrier = policy => {
  return `${policy.policyMonthsDuration} Months`
}

const getLabelStandAlone = (plan, policy, policies) => {
  const duration = policy.policyDuration

  return policies && +policies > 1 ? `${policies}x${duration} Days` : `${duration} Days`
}

export default function getCoverageLabel({ plan, duration = null, policies = null }) {
  const { policy } = getPolicy({ plan, duration, policies })

  if (enableMultiCarrierPlans()) {
    return getLabelMultiCarrier(policy)
  } else {
    return getLabelStandAlone(plan, policy, policies)
  }
}
